import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from "react-modal";
import "./ShareJob.css";

const ShareJob = (props) => {
  const [openModel, setopenModel] = useState(false);
  const [userData, setUserData] = useState({ userName: '', referralCode: '' });

  useEffect(() => {
    setopenModel(props.isOpen);
    const userDataString = window.localStorage.getItem("UserData");
    if (userDataString) {
      const user = JSON.parse(userDataString);
      setUserData({
        userName: `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'User',
        referralCode: user.refferal_code || ''
      });
    }
  }, [props.isOpen]);

  const formatJobId = (id) => {
    if (!id) return 'N/A';
    return `#${String(id).padStart(5, '0')}`;
  };

  const generateFuelShareMessage = () => {
    const message = `Hey! It's ${userData.userName || 'User'} 🙌\nI found this Gig for you on GigFWS and I am using GigFWS for a while now, it helps me earn and also get the job done.\n\n💼 ${props.jobData?.job_title || 'Job'}\n🆔 Job ID: ${formatJobId(props.jobData?.id)}\n\nUse my referral code ${userData.referralCode || 'XXXXX'} when accessing the app and applying.\n\nGet the app here:\nAndroid: https://play.google.com/store/apps/details?id=com.gigfws \niOS: https://apps.apple.com/in/app/gigfws-post-apply-gig-jobs/id6752988240`;
    return message;
  };

  const copyFuelShareMessage = () => {
    navigator.clipboard.writeText(generateFuelShareMessage()).then(() => {
      toast.success('Job sharing message copied to clipboard!');
    }).catch(() => {
      toast.error('Failed to copy message');
    });
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={() => setopenModel(false)}
      style={customStyles}
      contentLabel="Share Job Modal"
      scrollable={true}
    >
      <div className="share-job-modal">
        <div className="share-job-container">
          <div className="share-job-header">
            <h2 className="share-job-title">Share this Job</h2>
            <button 
              type="button" 
              className="close-btn" 
              onClick={() => props.toggle()}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          
          <div className="share-job-content">
            <p className="share-job-description">
              Want to share this job with referral message? Copy the message below and send it through your preferred channel.
            </p>
            
            <div className="job-details">
              <div className="job-detail-item">
                <span className="job-detail-label">Job ID:</span>
                <span className="job-detail-value">{formatJobId(props.jobData?.id)}</span>
              </div>
              <div className="job-detail-item">
                <span className="job-detail-label">Job Title:</span>
                <span className="job-detail-value">{props.jobData?.job_title}</span>
              </div>
              <div className="job-detail-item">
                <span className="job-detail-label">Category:</span>
                <span className="job-detail-value">{props.jobData?.category_full_name || props.jobData?.category}</span>
              </div>
            </div>

            <div className="referral-message-section">
              <div className="referral-link-section">
                <div className="link-container">
                  <div className="referral-message-display">
                    Hey! It's {userData.userName || 'User'} 🙌<br/><br/>
                    I found this Gig for you on <span className="app-name">GigFWS</span> and I am using GigFWS for a while now, it helps me earn and also get the job done.<br/><br/>
                    💼 {props.jobData?.job_title || 'Job'}<br/>
                    🆔 Job ID: {formatJobId(props.jobData?.id)}<br/><br/>
                    Use my referral code <span className="referral-code-highlight">{userData.referralCode || 'XXXXX'}</span> when accessing the app and applying.<br/><br/>
                    <span className="download-text">Get the app here:</span><br/>
                    Android: <a href="https://play.google.com/store/apps/details?id=com.futureworkforce" className="app-link">https://play.google.com/store/apps/details?id=com.gigfws</a><br/>
                    iOS: <a href="https://apps.apple.com/in/app/gigfws-post-apply-gig-jobs/id6752988240" className="app-link">https://apps.apple.com/app/gigfws</a> 
                  </div>
                </div>
                
                <button 
                  className="copy-referral-btn"
                  onClick={copyFuelShareMessage}
                >
                  Copy Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
    border: "none",
    padding: "0",
  },
  overlay: { 
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
};

export default ShareJob;

